import './Sistemas.css';
import { IconeCaminhao, IconeChave, IconeCheck, IconeSeta } from '../Icones/Icones';
import { CTA_TRANSPORTES, TORQUE_DEMO_URL } from '../../config';

const SISTEMAS = [
    {
        id: 'torque',
        nome: 'Torque',
        categoria: 'Gestão para oficina mecânica',
        selo: 'Demonstração disponível',
        Icone: IconeChave,
        descricao:
            'Tudo o que a oficina precisa num lugar só, do orçamento à entrega do carro. Feito para usar no celular, no meio do dia a dia da oficina.',
        funcionalidades: [
            'Ordens de serviço e orçamentos',
            'Clientes e histórico de cada veículo',
            'Agenda e lembretes de manutenção',
            'Controle financeiro e comissão de mecânicos',
        ],
        cta: { texto: 'Testar demonstração grátis', url: TORQUE_DEMO_URL },
    },
    {
        id: 'transp',
        nome: 'Gerenciador de Transportes',
        categoria: 'Gestão para transportadoras',
        selo: 'Em uso por cliente',
        Icone: IconeCaminhao,
        descricao:
            'Controle os embarques, acompanhe a qualidade das entregas e veja para onde vai o financeiro, com acesso definido por usuário.',
        funcionalidades: [
            'Controle de embarques pelo sistema e pelo app mobile',
            'Indicadores de qualidade e pontualidade das cargas',
            'Projeção financeira com base nos embarques',
            'Manutenção e checklist da frota',
        ],
        cta: CTA_TRANSPORTES,
    },
];

function Sistemas() {
    return (
        <section id="sistemas" className="secao sistemas">
            <div className="container">
                <div className="secao-cabecalho revelar">
                    <span className="rotulo">Produtos C1010</span>
                    <h2 className="titulo-secao">Nossos sistemas</h2>
                    <p className="subtitulo-secao">
                        Dois produtos que nasceram de problemas reais de clientes reais.
                    </p>
                </div>

                <div className="sistemas-grade">
                    {SISTEMAS.map(({ id, nome, categoria, selo, Icone, descricao, funcionalidades, cta }, i) => (
                        <article key={id} className={`sistema sistema-${id} revelar`} style={{ '--atraso': `${i * 0.12}s` }}>
                            <div className="sistema-topo">
                                <span className="sistema-icone">
                                    <Icone tamanho={28} />
                                </span>
                                <span className="sistema-selo">{selo}</span>
                                <Icone className="sistema-icone-fundo" tamanho={180} />
                            </div>

                            <div className="sistema-corpo">
                                <p className="sistema-categoria">{categoria}</p>
                                <h3 className="sistema-nome">{nome}</h3>
                                <p className="sistema-descricao">{descricao}</p>

                                <p className="sistema-lista-titulo">Principais funcionalidades</p>
                                <ul className="sistema-lista">
                                    {funcionalidades.map((item) => (
                                        <li key={item}>
                                            <span className="sistema-check"><IconeCheck tamanho={14} /></span>
                                            {item}
                                        </li>
                                    ))}
                                </ul>

                                <a href={cta.url} className="btn sistema-cta" target="_blank" rel="noopener noreferrer">
                                    {cta.texto}
                                    <IconeSeta tamanho={18} />
                                </a>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Sistemas;
